<template>
	<div v-if="request.method && request.endpoint">
		<div class="textRequest">Endpoint</div>
		<div class="request">
			<div :class="request.method">{{request.method}}</div>
			<div class="endpoint">{{request.endpoint}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'RequestView',
		props:{
			request: Object
		}
	}
</script>

<style>
	.request {
		display: flex;
		margin: 10px 0px;
	}

	.textRequest {
		font-family: 'Paralucent';
		font-weight: 500;
		font-size: 14px;
	}

	.endpoint {
		background-color: #FAFAFA;
		font-family: 'Courier New', Courier, monospace;
		padding: 7px;
	}

	.GET {
		background-color: dodgerblue;
	}

	.POST {
		background-color: limegreen;
	}

	.PUT {
		background-color: orange;
	}

	.DELETE {
		background-color: orangered;
	}

	.GET, .POST, .PUT, .DELETE {
		align-items: center;
		color: #FAFAFA;
		justify-content: center;
		letter-spacing: 1px;
		padding: 7px;
		width: 100px;
	}
</style>



// WEBPACK FOOTER //
// src/components/documentation/RequestView.vue